export const allowedPermissions = [
    {
        text: 'المنشأة',
        permissions: [
            {
                text: 'تعديل بيانات المنشأة',
                codename: 'change_business'
            }
        ]
    },
    {
        text: 'المستخدمين',
        permissions: [
            {
                text: 'إضافة مستخدم',
                codename: 'add_user'
            },
            {
                text: 'تعديل مستخدم',
                codename: 'change_user'
            },
            {
                text: 'حذف مستخدم',
                codename: 'delete_user'
            }
        ]
    },
    {
        text: 'المقايسات',
        permissions: [
            {
                text: 'إضافة مقايسة',
                codename: 'add_estimation'
            },
            {
                text: 'تعديل مقايسة',
                codename: 'change_estimation'
            },
            {
                text: 'حذف مقايسة',
                codename: 'delete_estimation'
            }
        ]
    },
    {
        text: 'المكاتب',
        permissions: [
            {
                text: 'إضافة مكتب',
                codename: 'add_office'
            },
            {
                text: 'تعديل مكتب',
                codename: 'change_office'
            },
            {
                text: 'حذف مكتب',
                codename: 'delete_office'
            }
        ]
    }
]